import { memo } from "react";
import { useDispatch } from "react-redux";
import $ from "jquery";

import { updateUserById } from "../../../../../../../actions/customer";

function DeactivateButton({ rowData }) {
  const dispatch = useDispatch();

  const deactivateUserById = () => {
    $.confirm({
      title: "Are you sure?",
      content: "Do you really want to deactivate this customer?",
      type: "red",
      buttons: {
        ok: {
          text: "Yes",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            updateUserById(
              {
                ...rowData,
                id: rowData._id,
                active: false,
                Remediation: true,
              },
              dispatch
            );
          },
        },
        cancel: function () {},
      },
    });
  };
  return (
    <button
      className="btn btn-secondary btn-sm mr-1"
      style={{ cursor: !rowData?.active ? "not-allowed" : "image-set" }}
      onClick={() => deactivateUserById()}
      disabled={!rowData?.active}
    >
      Deactivate
    </button>
  );
}

export default memo(DeactivateButton);
